var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-page-top-section',{attrs:{"title":_vm.$t('absent_log')}}),_vm._v(" "),_c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options},on:{"getFilteredValues":_vm.setQueryObject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }